import { render, staticRenderFns } from "./LessonGroupResults.vue?vue&type=template&id=81a7bdda"
import script from "./LessonGroupResults.vue?vue&type=script&lang=js"
export * from "./LessonGroupResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81a7bdda')) {
      api.createRecord('81a7bdda', component.options)
    } else {
      api.reload('81a7bdda', component.options)
    }
    module.hot.accept("./LessonGroupResults.vue?vue&type=template&id=81a7bdda", function () {
      api.rerender('81a7bdda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/ExamReport/LessonGroupResults.vue"
export default component.exports